export const heatMapTypes = ["kgPerNm", "propulsionPower", "tonnesPerDay"];
//# sourceMappingURL=heatMapTypes.js.map